(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-hero--backup"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    // Quantity Selector
    const minusBtn = document.querySelector(".qty-btn.minus");
    const plusBtn = document.querySelector(".qty-btn.plus");
    const input = document.querySelector(".qty-input");

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener("click", function () {
        const current = parseInt(input.value);
        if (current > 1) input.value = current - 1;
      });

      plusBtn.addEventListener("click", function () {
        const current = parseInt(input.value);
        input.value = current + 1;
      });
    }

    // Purchase Option Selection
    const radioButtons = document.querySelectorAll("input[name='purchase_option']");

    radioButtons.forEach(function (radio) {
      radio.addEventListener("change", function () {
        document.querySelectorAll(".purchase-option--wrapper").forEach(function (wrapper) {
          wrapper.classList.remove("purchase-option--active");
        });
        this.closest(".purchase-option--wrapper").classList.add("purchase-option--active");
      });

      if (radio.checked) {
        radio.closest(".purchase-option--wrapper").classList.add("purchase-option--active");
      }
    });

    // Variant Selector Logic
    var variants = window.__productVariants || [];
    var variantRadios = document.querySelectorAll('input[type="radio"]');
    var hiddenVariantInput = document.getElementById('selected-variant-id');

    if (!hiddenVariantInput) {
      console.error('Hidden variant input #selected-variant-id not found!');
      return;
    }

    function updateVariant() {
      var selectedOptions = {};

      variantRadios.forEach(function (radio) {
        if (radio.checked) {
          selectedOptions[radio.name] = radio.value;
        }
      });

      var matchedVariant = variants.find(function (variant) {
        return variant.options.every(function (optValue, idx) {
          var key = Object.keys(selectedOptions)[idx];
          return selectedOptions[key] === optValue;
        });
      });

      if (matchedVariant) {
        hiddenVariantInput.value = matchedVariant.id;
      }

      variantRadios.forEach(function (radio) {
        var label = document.querySelector('label[for="' + radio.id + '"]');
        if (label) {
          label.classList.toggle('option--active', radio.checked);
        }
      });
    }

    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', updateVariant);
    });

    updateVariant();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-hero"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Quantity Selector
    const minusBtn = document.querySelector('.qty-btn.minus');
    const plusBtn = document.querySelector('.qty-btn.plus');
    const input = document.querySelector('.qty-input');

    if (minusBtn && plusBtn && input) {
      minusBtn.addEventListener('click', function () {
        const current = parseInt(input.value);
        if (current > 1) input.value = current - 1;
      });

      plusBtn.addEventListener('click', function () {
        const current = parseInt(input.value);
        input.value = current + 1;
      });
    }

    // Purchase Option Selector
    const radioButtons = document.querySelectorAll("input[name='purchase_option']");
    const sellingPlanInput = document.getElementById('hidden_selling_plan_input');

    radioButtons.forEach(function (radio) {
      radio.addEventListener('change', function () {
        document.querySelectorAll('.purchase-option--wrapper').forEach(function (wrapper) {
          wrapper.classList.remove('purchase-option--active');
        });
        this.closest('.purchase-option--wrapper').classList.add('purchase-option--active');

        // Update selling_plan hidden input
        if (this.value === 'subscription') {
          const planId = sellingPlanInput.dataset.subscriptionPlanId;
          sellingPlanInput.value = planId;
        } else {
          sellingPlanInput.removeAttribute('value');
        }
      });

      // Initial checked state
      if (radio.checked) {
        radio.closest('.purchase-option--wrapper').classList.add('purchase-option--active');
        if (radio.value === 'subscription') {
          const planId = sellingPlanInput.dataset.subscriptionPlanId;
          sellingPlanInput.value = planId;
        } else {
          sellingPlanInput.removeAttribute('value');
        }
      }
    });

    // Custom Carousel Logic
    function initCustomCarousel() {
      const mainImage = document.getElementById('main-carousel-image');
      const thumbnails = document.querySelectorAll('.pdp-hero-carousel__thumbnails .pdp-hero-carousel__thumb');
      thumbnails.forEach(function (thumb, idx) {
        thumb.addEventListener('click', function () {
          thumbnails.forEach((t) => t.classList.remove('active'));
          this.classList.add('active');
          mainImage.src = this.src;
        });
      });
      // Set first as active
      if (thumbnails.length) thumbnails[0].classList.add('active');
    }

    initCustomCarousel();

    // Variant Selector Logic
    var variants = window.__productVariants || [];
    var variantRadios = document.querySelectorAll('input[type="radio"]');
    var hiddenVariantInput = document.getElementById('selected-variant-id');
    let selectedFlavorName = document.getElementById('selected-flavor-name');

    function updateCarouselForVariant(variantId) {
      const variantData = window.subscriptionVariantData.variants.find((v) => v.id == variantId);
      if (!variantData) return;
      // Update main image
      document.getElementById('pdp-hero-carousel-wrapper').innerHTML = `
      <img id="main-carousel-image" src="${variantData.image}" alt="" class="pdp-hero-carousel__main" />
    `;
      // Update thumbnails
      let thumbs = `<img class="pdp-hero-carousel__thumb active" src="${variantData.image}" data-index="0" alt="Main image" />`;
      variantData.variant_images.forEach((img, idx) => {
        thumbs += `<img class="pdp-hero-carousel__thumb" src="${img}" data-index="${idx + 1}" alt="Thumbnail ${
          idx + 1
        }" />`;
      });
      document.querySelector('.pdp-hero-carousel__thumbnails').innerHTML = thumbs;
      // Re-initialize thumbnail click events
      initCustomCarousel();
    }

    function updateVariant() {
      var selectedOptions = {};
      variantRadios.forEach(function (radio) {
        if (radio.checked) {
          selectedOptions[radio.name] = radio.value;
        }
      });
      var matchedVariant = variants.find(function (variant) {
        return variant.options.every(function (optValue, idx) {
          var key = Object.keys(selectedOptions)[idx];
          return selectedOptions[key] === optValue;
        });
      });
      if (matchedVariant) {
        hiddenVariantInput.value = matchedVariant.id;
        selectedFlavorName.innerText = matchedVariant.options[0];
        updateCarouselForVariant(matchedVariant.id);

        // Update button text and state based on availability and preorder status
        const variantData = window.subscriptionVariantData.variants.find((v) => v.id == matchedVariant.id);
        const addToCartButton = document.getElementById('add-to-cart-button');
        // Check if variant is available
        if (!matchedVariant.available) {
          addToCartButton.textContent = 'Sold Out';
          addToCartButton.disabled = true;
        } else {
          // Check preorder status
          if (variantData && variantData.variant_preorder === 'true') {
            addToCartButton.textContent = 'Pre-order';
            addToCartButton.disabled = false;
          } else {
            addToCartButton.textContent = 'Add to cart';
            addToCartButton.disabled = false;
          }
        }
        

        // Update URL with variant ID
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url);
      }
      variantRadios.forEach(function (radio) {
        var label = document.querySelector('label[for="' + radio.id + '"]');
        if (label) {
          label.classList.toggle('option--active', radio.checked);
        }
      });
    }

    variantRadios.forEach(function (radio) {
      radio.addEventListener('change', updateVariant);
    });
    updateVariant();


  });
  } catch(e) { console.error(e); }
})();

})();
